/* Maïsôn MIQU — Theme JavaScript */

document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initAccordions();
  initCartDrawer();
  initGallery();
  initFadeIn();
  initDirectPurchase();
});

/* Header scroll */
function initHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  const onScroll = () => {
    header.classList.toggle('scrolled', window.scrollY > 50);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
}

/* Accordion */
function initAccordions() {
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      const content = trigger.nextElementSibling;

      trigger.setAttribute('aria-expanded', !expanded);
      content.classList.toggle('open', !expanded);
    });
  });
}

/* Cart drawer */
function initCartDrawer() {
  const overlay = document.querySelector('.cart-overlay');
  // Old custom drawer only. Dawn's drawer (#CartDrawer) shares the class and runs itself.
  const drawer  = document.querySelector('.cart-drawer:not(#CartDrawer)');
  const openBtns = document.querySelectorAll('[data-cart-open]');
  const closeBtn = document.querySelector('.cart-drawer__close');

  if (!drawer) return;

  const open  = () => { overlay?.classList.add('open'); drawer.classList.add('open'); document.body.style.overflow = 'hidden'; };
  const close = () => { overlay?.classList.remove('open'); drawer.classList.remove('open'); document.body.style.overflow = ''; };

  openBtns.forEach(btn => btn.addEventListener('click', open));
  closeBtn?.addEventListener('click', close);
  overlay?.addEventListener('click', close);

  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
}

/* Product gallery thumbnails */
function initGallery() {
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');

  if (!thumbs.length || !mainImg) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.querySelector('img')?.src;
      if (src) mainImg.src = src;

      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });
}

/* Intersection Observer fade-in */
/* Purchase: empty the cart, add this variant alone, then go straight to
   checkout — so the shopper buys only this item, the way the wallet buttons
   behaved. Rendered by snippets/buy-buttons.liquid in the slot those buttons
   would otherwise take, so the two never appear together. */
function initDirectPurchase() {
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-direct-purchase]');
    if (!button || button.disabled) return;

    event.preventDefault();

    const form = button.closest('form');
    if (!form) return;

    const productForm = form.closest('product-form');
    const spinner = button.querySelector('.loading__spinner');

    button.disabled = true;
    spinner?.classList.remove('hidden');

    try {
      /* Empty the cart first so the shopper checks out with this item alone,
         the way the wallet buttons used to behave. Anything they had in the
         cart is discarded — including if they then abandon checkout. */
      const cleared = await fetch(`${button.dataset.clearUrl}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
      });

      if (!cleared.ok) throw new Error('The cart could not be emptied.');

      const response = await fetch(`${button.dataset.addUrl}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });

      if (!response.ok) {
        const problem = await response.json().catch(() => ({}));
        throw new Error(problem.description || 'This could not be added.');
      }

      /* POST to the cart route with `checkout` rather than sending the browser
         to /checkout, so the shopper stays on the right locale and market. */
      const checkout = document.createElement('form');
      checkout.method = 'post';
      checkout.action = button.dataset.cartUrl;

      const field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'checkout';
      field.value = '1';

      checkout.appendChild(field);
      document.body.appendChild(checkout);
      checkout.submit();
    } catch (error) {
      button.disabled = false;
      spinner?.classList.add('hidden');

      /* Reuse Dawn's own error strip rather than an alert. */
      const message = productForm?.querySelector('.product-form__error-message');
      const wrapper = productForm?.querySelector('.product-form__error-message-wrapper');

      if (message && wrapper) {
        message.textContent = error.message;
        wrapper.removeAttribute('hidden');
      }
    }
  });

  /* On a variant change Dawn only toggles its own submit button — it does not
     re-render this area — so mirror that button's disabled state onto Purchase
     instead of letting it go stale on a sold-out variant. */
  const mirrorState = (submit) => {
    const purchase = submit.closest('form')?.querySelector('[data-direct-purchase]');
    if (purchase) purchase.disabled = submit.hasAttribute('disabled');
  };

  document.querySelectorAll('.product-form__submit[name="add"]').forEach(mirrorState);

  new MutationObserver((records) => {
    records.forEach(({ target, attributeName }) => {
      if (attributeName !== 'disabled') return;
      /* Purchase carries product-form__submit too but never name="add", so
         mirroring onto it cannot retrigger this observer. */
      if (target instanceof HTMLElement && target.matches('.product-form__submit[name="add"]')) {
        mirrorState(target);
      }
    });
  }).observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled'],
  });
}

/* Fade-and-rise on scroll, once. [data-fade] content is visible by default
   (assets/theme.css): only what sits below the fold at load is hidden, then
   revealed over 0.8s as it scrolls in. Anything already on screen, or scrolled
   past, is never hidden, so the first view never waits on a fade. With reduced
   motion, or without IntersectionObserver, nothing is hidden at all. */
function initFadeIn() {
  const els = document.querySelectorAll('[data-fade]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  const fold = window.innerHeight;

  els.forEach(el => {
    if (el.getBoundingClientRect().top < fold) return;
    el.classList.add('is-fade-pending');
    observer.observe(el);
  });
}

/* Add to cart (Shopify AJAX) */
document.querySelectorAll('[data-add-to-cart]').forEach(form => {
  form.addEventListener('submit', async e => {
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const variantId = form.querySelector('[name="id"]')?.value;

    if (!variantId) return;

    // Dawn's cart drawer (or notification) re-renders itself from the sections we ask for.
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const canRenderCart = cart && typeof cart.renderContents === 'function' && typeof cart.getSectionsToRender === 'function';
    const payload = { id: Number(variantId), quantity: 1 };
    if (canRenderCart) {
      payload.sections = cart.getSectionsToRender().map(section => section.id).join(',');
      payload.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
    }

    btn.textContent = 'Adding...';
    btn.disabled = true;

    const reset = delay => setTimeout(() => {
      btn.textContent = 'Add to Cart';
      btn.disabled = false;
    }, delay);

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await res.json();

      if (!res.ok || data.status) {
        reset(0);
        return;
      }

      btn.textContent = 'Added';

      if (canRenderCart) {
        cart.classList.remove('is-empty');
        cart.renderContents(data);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'miqu-card', productVariantId: payload.id, cartData: data });
        }
      } else {
        updateCartCount();
      }

      reset(2000);
    } catch {
      reset(0);
    }
  });
});

async function updateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  } catch {}
}

async function loadCartItems() {
  const body = document.querySelector('.cart-drawer__body');
  if (!body) return;

  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    if (cart.items.length === 0) {
      body.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
      return;
    }

    const html = cart.items.map(item => `
      <div style="display:flex;gap:1rem;padding:1rem 0;border-bottom:1px solid var(--color-border)">
        <img src="${item.image}" alt="${item.title}" style="width:70px;height:88px;object-fit:cover;background:var(--color-section)">
        <div style="flex:1">
          <p style="font-size:0.8rem;font-weight:400;color:var(--color-text);margin-bottom:0.2rem;letter-spacing:0.04em">${item.title}</p>
          <p style="font-size:0.75rem;color:var(--color-text-muted);margin:0">$${(item.final_price / 100).toFixed(2)}</p>
        </div>
      </div>
    `).join('');

    const footer = document.querySelector('.cart-drawer__footer');
    if (footer) {
      footer.innerHTML = `
        <div style="display:flex;justify-content:space-between;margin-bottom:1rem;font-size:0.8rem;letter-spacing:0.08em;text-transform:uppercase">
          <span>Total</span>
          <span>$${(cart.total_price / 100).toFixed(2)}</span>
        </div>
        <a href="/checkout" class="btn btn--primary" style="width:100%;text-align:center;display:block">Complete Order</a>
        <a href="/cart" style="display:block;text-align:center;margin-top:0.8rem;font-size:0.75rem;color:var(--color-text-muted);letter-spacing:0.1em;text-transform:uppercase">View Cart</a>
      `;
    }

    body.innerHTML = html;
  } catch {}
}

/* Filter buttons */
document.querySelectorAll('.filter-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const filter = btn.dataset.filter;

    document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    const items = document.querySelectorAll('.product-grid__item');
    let visibleCount = 0;

    items.forEach(item => {
      const tags = item.dataset.tags || '';
      const match = filter === 'all' || tags.split(',').map(t => t.trim()).includes(filter);
      item.style.display = match ? '' : 'none';
      if (match) visibleCount++;
    });

    const noResults = document.querySelector('.collection-no-results');
    if (noResults) noResults.style.display = visibleCount === 0 ? 'block' : 'none';
  });
});

/* Mobile menu */
const mobileToggle = document.querySelector('.mobile-menu-toggle');
const mobileNav    = document.querySelector('.mobile-nav');

mobileToggle?.addEventListener('click', () => {
  const expanded = mobileToggle.getAttribute('aria-expanded') === 'true';
  mobileToggle.setAttribute('aria-expanded', !expanded);
  mobileNav?.classList.toggle('open', !expanded);
});

updateCartCount();
